import { useQuery } from '@tanstack/react-query';
import { APITypes } from '../../primary-record-types';
import { getCanAddMedicalProfileCacheKey, onPaymentStatusOrProfileCountUpdate } from './cacheKeys';
import { appAPI } from '../../utils/api';
import urls from '../../utils/urls';
import { getIntl } from '../../utils/intl';
import { useQueryErrorNotify } from '../useQueryCallbacks';

const intl = getIntl('useCanAddMedicalProfile', {
    loadError: 'Failed to check if a medical profile can be added',
});

export type UseCanAddMedicalProfileResponse = {
    canAddMedicalProfile: boolean;
    isLoadingCanAddMedicalProfile: boolean;
};

export const resetCanAddMedicalProfileCache = (): void => {
    onPaymentStatusOrProfileCountUpdate.resetCache({})();
};

export const useCanAddMedicalProfile = (): UseCanAddMedicalProfileResponse => {
    const query = useQuery<APITypes.medicalProfileService.GetCanAddMedicalProfileResponse>({
        queryKey: getCanAddMedicalProfileCacheKey(),
        queryFn: async (): Promise<APITypes.medicalProfileService.GetCanAddMedicalProfileResponse> => {
            return appAPI.get<APITypes.medicalProfileService.GetCanAddMedicalProfileResponse>(
                urls.api.paymentStatus.canAddProfile,
            );
        },
    });

    useQueryErrorNotify(query, intl('loadError'));

    return {
        canAddMedicalProfile: query.data?.canAddMedicalProfile ?? false,
        isLoadingCanAddMedicalProfile: query.isLoading,
    };
};
